'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _isEqual2 = _interopRequireDefault(require("lodash/isEqual"));
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _AppWrapper = _interopRequireDefault(require("AppWrapper"));
var _PagesExports = _interopRequireDefault(require("PagesExports"));
var _getErrorsFromResponse = _interopRequireDefault(require("Components/Forms/Functions/getErrorsFromResponse"));
var _ErrorRecoveryModal = _interopRequireDefault(require("Modals/ErrorRecoveryModal"));
var _Loader = _interopRequireDefault(require("Pure/Loader"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const {
  app,
  qwest
} = window;
function formatRoutes() {
  let authorizations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return authorizations.filter(auth => auth.front && auth.front.reactComponent).reduce(function (accumulator, auth) {
    accumulator[auth.front.url] = {
      id: auth.identifier,
      component: _PagesExports.default[auth.front.reactComponent]
    };
    return accumulator;
  }, {});
}
class Application extends _react.Component {
  constructor() {
    var _app$state$session$us;
    super(...arguments);
    (0, _defineProperty2.default)(this, "state", {
      roles: ((_app$state$session$us = app.state.session.user) === null || _app$state$session$us === void 0 ? void 0 : _app$state$session$us.roles) || [],
      user: app.state.session.user || {},
      routes: formatRoutes(app.state.session.routes),
      loading: app.state.session.fetched !== true,
      error_modal: this.props.error === true
    });
    (0, _defineProperty2.default)(this, "closeRecoveryModal", () => this.setState({
      error_modal: false
    }));
    (0, _defineProperty2.default)(this, "setStateRoutes", _ref => {
      var _app$state$session;
      let {
        source,
        data = {}
      } = _ref;
      const component = this,
        props = this.props,
        state = this.state;
      const allowed_routes = formatRoutes((_app$state$session = app.state.session) === null || _app$state$session === void 0 ? void 0 : _app$state$session.routes);
      if ((0, _isEqual2.default)(state.routes, allowed_routes)) {
        return;
      }
      component.setState({
        routes: allowed_routes
      });
    });
    (0, _defineProperty2.default)(this, "handleLogout", _ref2 => {
      let {
        source,
        data = {}
      } = _ref2;
      const component = this,
        props = this.props,
        state = this.state;
      if (data.update_routes !== true) return;
      component.setState({
        loading: true
      });
      qwest.post('/get-session').then(function (xhr, response) {
        app.state.session = response || undefined;
        app.emit({
          event: 'sessionChange',
          source: component
        });
        component.setState({
          loading: false
        });
        if (typeof data.then === 'function') {
          data.then();
        }
      }).catch(function (error, xhr, response) {
        console.error((response === null || response === void 0 ? void 0 : response.error) || (response === null || response === void 0 ? void 0 : response.raw) || error);
        component.setState(_objectSpread({}, (0, _getErrorsFromResponse.default)({
          response: response
        })));
      });
    });
    (0, _defineProperty2.default)(this, "refreshSession", _ref3 => {
      let {
        source,
        data = {}
      } = _ref3;
      const component = this,
        props = this.props,
        state = this.state;
      if (source !== 'initState' && data.update_routes !== true) return;
      component.setState({
        loading: true
      });
      qwest.post('/get-session').then(function (xhr, response) {
        app.state.session = response || undefined;
        app.emit({
          event: 'sessionChange',
          source: component
        });
        component.setState({
          loading: false
        });
        if (typeof data.then === 'function') data.then();
      }).catch(function (error, xhr, response) {
        console.error((response === null || response === void 0 ? void 0 : response.error) || (response === null || response === void 0 ? void 0 : response.raw) || error);
        component.setState(_objectSpread({}, (0, _getErrorsFromResponse.default)({
          response: response
        })));
      });
    });
  }
  componentDidMount() {
    var _app$state$session2;
    const component = this,
      props = this.props,
      state = this.state;
    app.push({
      event: 'sessionChange',
      cb: component.setStateRoutes,
      global: true
    });
    app.push({
      event: 'sessionNeedsRefresh',
      cb: component.refreshSession,
      global: true
    });
    app.push({
      event: 'logout',
      cb: component.handleLogout,
      global: true
    });
    if (((_app$state$session2 = app.state.session) === null || _app$state$session2 === void 0 ? void 0 : _app$state$session2.fetched) !== true) {
      component.refreshSession({
        source: 'initState'
      });
    }
  }
  componentDidUpdate(prev_props, prev_state) {
    const component = this,
      props = this.props,
      state = this.state;
    if (prev_props.error !== true && props.error === true) {
      component.setState({
        error_modal: props.error === true
      });
    }
  }
  componentWillUnmount() {
    const component = this,
      props = this.props,
      state = this.state;
    app.delete({
      event: 'sessionChange',
      cb: component.setStateRoutes,
      global: true
    });
    app.delete({
      event: 'sessionNeedsRefresh',
      cb: component.refreshSession,
      global: true
    });
    app.delete({
      event: 'logout',
      cb: component.handleLogout,
      global: true
    });
  }
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    let routes = Object.keys(state.routes).map(function (path, i) {
      const render_data = state.routes[path];
      const PageComponent = render_data.component;
      const route = {
        path: path,
        element: /*#__PURE__*/_react.default.createElement(PageComponent, null)
      };
      return route;
    });
    const NotFound = _PagesExports.default['NotFoundPage'];
    routes.push({
      path: '*',
      element: /*#__PURE__*/_react.default.createElement(NotFound, null)
    });
    let output = /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.BrowserRouter, null, /*#__PURE__*/_react.default.createElement(_AppWrapper.default, {
      routes: routes
    })), /*#__PURE__*/_react.default.createElement(_ErrorRecoveryModal.default, {
      open: state.error_modal === true,
      onClose: component.closeRecoveryModal
    }));
    const loader = /*#__PURE__*/_react.default.createElement(_Loader.default, {
      className: "c-loader",
      bemit: ['white', 'bg-primary']
    });
    return state.loading ? loader : output;
  }
}
exports.default = Application;
